const initialProps = {
  ticketThreeDetalle: [],
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "CREATE_TICKET_THREE_DETALLE":
      return {
        ...state,
        ticketThreeDetalle: [...state.ticketThreeDetalle, action.payload],
      };
    case "UPDATE_TICKET_THREE_DETALLE":
      return {
        ...state,
        ticketThreeDetalle: action.payload,
      };
    case "REMOVE_TICKET_THREE_DETALLE":
      return {
        ...state,
        ticketThreeDetalle: action.payload,
      };
    default:
      return state;
  }
}
